import { Component, OnInit } from '@angular/core';
import {HttpService} from '../../../services/http.service';

@Component({
  selector: 'app-calc-log',
  templateUrl: './calc-log.component.html',
  styleUrls: ['./calc-log.component.css']
})
export class CalcLogComponent implements OnInit {

  vin: string = '';
  logList: any;

  constructor(private http: HttpService) { }

  ngOnInit(): void {
  }

  searchVin() {
    this.http.fetchCalcLogs(this.vin).subscribe((res) => {
      this.logList = res;
    });
  }
}
